/**
 * @name umi 的路由配置
 * @description 只支持 path,component,routes,redirect,wrappers,name,icon 的配置
 * @param path  path 只支持两种占位符配置，第一种是动态参数 :id 的形式，第二种是 * 通配符，通配符只能出现路由字符串的最后。
 * @param component 配置 location 和 path 匹配后用于渲染的 React 组件路径。可以是绝对路径，也可以是相对路径，如果是相对路径，会从 src/pages 开始找起。
 * @param routes 配置子路由，通常在需要为多个路径增加 layout 组件时使用。
 * @param redirect 配置路由跳转
 * @param wrappers 配置路由组件的包装组件，通过包装组件可以为当前的路由组件组合进更多的功能。 比如，可以用于路由级别的权限校验
 * @param name 配置路由的标题，默认读取国际化文件 menu.ts 中 menu.xxxx 的值，如配置 name 为 login，则读取 menu.ts 中 menu.login 的取值作为标题
 * @param icon 配置路由的图标，取值参考 https://ant.design/components/icon-cn， 注意去除风格后缀和大小写，如想要配置图标为 <StepBackwardOutlined /> 则取值应为 stepBackward 或 StepBackward，如想要配置图标为 <UserOutlined /> 则取值应为 user 或者 User
 * @doc https://umijs.org/docs/guides/routes
 */
export default [
  {
    path: '/user',
    layout: false,
    is_show: false,
    routes: [
      {
        name: 'login',
        path: '/user/login',
        component: './user/login',
        is_show: false,
      },
    ],
  },

  {
    path: '/welcome',
    name: 'welcome',
    icon: 'home',
    component: './Welcome',
    is_show: true,
  },
  // {
  //   path: '/dashboard',
  //   name: 'dashboard',
  //   icon: 'dashboard',
  //   component: './dashboard',
  //   is_show: true,
  // },
  {
    path: '/',
    redirect: '/welcome',
  },
  {
    path: '*',
    layout: false,
    component: './404',
  },
  {
    name: 'access-control',
    icon: 'lock',
    path: '/access-control',
    routes: [{
        name: 'role-management',
        path: '/access-control/role-management',
        component: './access-control/role-management',
      },{
        name: 'menu-management',
        path: '/access-control/menu-management',
        component: './access-control/menu-management',
      },{
        name: 'user-management',
        path: '/access-control/user-management',
        component: './access-control/user-management',
      },],
  },
  {
    name: 'device-control',
    icon: 'control',
    path: '/device-control',
      routes: [{
        name: 'list-device',
        path: '/device-control/list-device',
        component: './device-control/list-device',
      },{
        name: 'series-device',
        path: '/device-control/series-device',
        component: './device-control/series-device',
      },{
        name: 'category-device',
        path: '/device-control/category-device',
        component: './device-control/category-device',
      },{
        name: 'model-device',
        path: '/device-control/model-device',
        component: './device-control/model-device',
      },{
        name: 'config-group-device',
        path: '/device-control/config-group-device',
        component: './device-control/config-group-device',
      },{
        name: 'config-device',
        path: '/device-control/config-device',
        component: './device-control/config-device',
      },{
        name: 'drink-list',
        path: '/device-control/drink-list',
        component: './device-control/drink-list',
      },{
        name: 'device-upgrade-package',
        path: '/device-control/device-upgrade-package',
        component: './device-control/device-upgrade-package',
      },{
        name: 'device-manual-document',
        path: '/device-control/device-manual-document',
        component: './device-control/device-manual-document',
      },{
        name: 'beverage-information',
        path: '/device-control/beverage-information',
        component: './device-control/beverage-information',
      },],
  },
  {
    name: 'order-control',
    icon: 'snippets',
    path: '/order-control',
    routes: [{
      name: 'list-order',
      path: '/order-control/list-order',
      component: './order-control/list-order',
    },],
  },
  {
    name: 'package-management',
    icon: 'cloud-upload',
    path: '/package-management',
    routes: [{
        name: 'application-upgrade-package',
        path: '/package-management/application-upgrade-package',
        component: './package-management/application-upgrade-package',
      },
      {
        name: 'coffee-upgrade-package',
        path: '/package-management/coffee-upgrade-package',
        component: './package-management/coffee-upgrade-package',
      },],
  },
  {
    name: 'application-management',
    icon: 'appstore',
    path: '/application-management',
    routes: [
      {
        name: 'application-account',
        path: '/application-management/application-account',
        component: './application-management/application-account',
      },
      {
        name: 'application-agreement',
        path: '/application-management/application-agreement',
        component: './application-management/application-agreement',
      },
    ],
  },
  // {
  //   // 升级包管理
  //   name: 'upgrade-package-management',
  //   icon: 'upgrade-package',
  //   path: '/upgrade-management',
  //   routes: [
  //     {
  //       name: 'upgrade-package-list',
  //       path: '/upgrade-management/upgrade-package-list',
  //       component: './upgrade-management/upgrade-package-list',
  //     },
  //   ],
  // }
];
